import { nanoid } from "@reduxjs/toolkit";

import shoes1 from "../../../../assets/KidsShoes/shoes1.png";
import shoes11 from "../../../../assets/KidsShoes/shoes11.png";
import shoes12 from "../../../../assets/KidsShoes/shoes12.png";
import shoes13 from "../../../../assets/KidsShoes/shoes13.png";

import shoes2 from "../../../../assets/KidsShoes/shoes2.png";
import shoes21 from "../../../../assets/KidsShoes/shoes21.png";
import shoes22 from "../../../../assets/KidsShoes/shoes22.png";
import shoes23 from "../../../../assets/KidsShoes/shoes23.png";

import shoes3 from "../../../../assets/KidsShoes/shoes3.png";
import shoes31 from "../../../../assets/KidsShoes/shoes31.png";
import shoes32 from "../../../../assets/KidsShoes/shoes32.png";
import shoes33 from "../../../../assets/KidsShoes/shoes33.png";

import shoes4 from "../../../../assets/KidsShoes/shoes4.png";
import shoes41 from "../../../../assets/KidsShoes/shoes41.png";
import shoes42 from "../../../../assets/KidsShoes/shoes42.png";
import shoes43 from "../../../../assets/KidsShoes/shoes43.png";

import shoes5 from "../../../../assets/KidsShoes/shoes5.png";
import shoes51 from "../../../../assets/KidsShoes/shoes51.png";
import shoes52 from "../../../../assets/KidsShoes/shoes52.png";
import shoes53 from "../../../../assets/KidsShoes/shoes53.png";

import shoes6 from "../../../../assets/KidsShoes/shoes6.png";
import shoes61 from "../../../../assets/KidsShoes/shoes61.png";
import shoes62 from "../../../../assets/KidsShoes/shoes62.png";
import shoes63 from "../../../../assets/KidsShoes/shoes63.png";

import shoes7 from "../../../../assets/KidsShoes/shoes7.png";
import shoes71 from "../../../../assets/KidsShoes/shoes71.png";
import shoes72 from "../../../../assets/KidsShoes/shoes72.png";
import shoes73 from "../../../../assets/KidsShoes/shoes73.png";

import shoes8 from "../../../../assets/KidsShoes/shoes8.png";
import shoes81 from "../../../../assets/KidsShoes/shoes81.png";
import shoes82 from "../../../../assets/KidsShoes/shoes82.png";
import shoes83 from "../../../../assets/KidsShoes/shoes83.png";

import shoes9 from "../../../../assets/KidsShoes/shoes9.png";
import shoes91 from "../../../../assets/KidsShoes/shoes91.png";
import shoes92 from "../../../../assets/KidsShoes/shoes92.png";
import shoes93 from "../../../../assets/KidsShoes/shoes93.png";

export const CasualShoesData = [
  {
    id: nanoid(),
    image: shoes1,
    title: "PUMA Men Rebound LayUp Lo Sneakers JR",
    price: 2999,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "PUMA White-Archive Green-PUMA Black",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "Combining retro and futuristic basketball-inspired style, this sleek sneaker features a perforated forefront, clean lines and the iconic",
    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information For any queries, please contact Customer Service at 080-35353535 or via customercareindia@puma.com .",
    productStory:
      "Combining retro and futuristic basketball-inspired style, this sleek sneaker features a perforated forefront, clean lines and the iconic PUMA Formstrip to have you commanding attention both on and off the court",

    detail: [
      {
        id: nanoid(),
        point: "Synthetic leather upper",
      },
      {
        id: nanoid(),
        point: "Non-marking rubber outsole",
      },
      {
        id: nanoid(),
        point: "Archive No. 1 Logo at tongue",
      },
      {
        id: nanoid(),
        point: "PUMA Formstrip at sides",
      },
      {
        id: nanoid(),
        point: "PUMA Cat Logo at lateral heel",
      },
      {
        id: nanoid(),
        point:
          "PUMA Youth style: recommended for older kids between 8 and 16 years",
      },
    ],

    manufacturer: [
      {
        id: nanoid(),
        point: "Fujian Province Good Brother Sports Equipment Co.Ltd.",
      },

      {
        id: nanoid(),
        point:
          "FCNMZ No.318 Meiling Road, Meishan Community, Meiling Street 362200 Jinjiang",
      },
    ],
    cardImages: [
      {
        id: nanoid(),
        imgCard: shoes1,
      },
      {
        id: nanoid(),
        imgCard: shoes11,
      },
      {
        id: nanoid(),
        imgCard: shoes12,
      },
      {
        id: nanoid(),
        imgCard: shoes13,
      },
    ],
  },
  {
    id: nanoid(),
    image: shoes2,
    title: "Racer V1 Men Sneakers ",
    price: 1699,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "PUMA Black-Zinnia-Electric Peppermint",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "These sneakers feature a colorblock design that's sure to make a statement on the playground. Crafted with a soft and breathable",
    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information For any queries, please contact Customer Service at 080-35353535 or via customercareindia@puma.com .",
    productStory:
      "These sneakers feature a colorblock design that's sure to make a statement on the playground. Crafted with a soft and breathable textile upper, they ensure a comfortable fit throughout the day. The practical hook and loop closure allows for quick and easy on-off, making them a perfect choice for kids on the go. Also featuring pull tabs for extra convenience, these sneakers combine functionality with a sporty look",

    detail: [
      {
        id: nanoid(),
        point: "Textile Upper",
      },
      {
        id: nanoid(),
        point:
          "Low boot construction & hook-and-loop closure gives an optimal fit",
      },
      {
        id: nanoid(),
        point: "PUMA Branding gives great design elevation",
      },
      {
        id: nanoid(),
        point: "Rubber outsole for better traction",
      },
    ],

    manufacturer: [
      {
        id: nanoid(),
        point: "SSIPL RETAIL LIMITED IN",
      },

      {
        id: nanoid(),
        point:
          "SIRMOUR VILL-MEHRUWALA,PO-BHAGANI, TEHSIL-PAONTASAHIB,DISTT-SIRMO HP 173025 PAONTASAHIB",
      },
    ],
    cardImages: [
      {
        id: nanoid(),
        imgCard: shoes2,
      },
      {
        id: nanoid(),
        imgCard: shoes21,
      },
      {
        id: nanoid(),
        imgCard: shoes22,
      },
      {
        id: nanoid(),
        imgCard: shoes23,
      },
    ],
  },
  {
    id: nanoid(),
    image: shoes3,
    title: "Racer V1 Kid's Sneakers Men",
    price: 2379,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "Eucalyptus-Rickie Orange-Yellow Sizzle",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "These sneakers feature a colorblock design that's sure to make a statement on the playground. Crafted with a soft and breathable",
    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information For any queries, please contact Customer Service at 080-35353535 or via customercareindia@puma.com .",
    productStory:
      "These sneakers feature a colorblock design that's sure to make a statement on the playground. Crafted with a soft and breathable textile upper, they ensure a comfortable fit throughout the day. The practical hook and loop closure allows for quick and easy on-off, making them a perfect choice for kids on the go. Also featuring pull tabs for extra convenience, these sneakers combine functionality with a sporty look",

    detail: [
      {
        id: nanoid(),
        point: "Textile Upper",
      },
      {
        id: nanoid(),
        point:
          "Low boot construction & hook-and-loop closure gives an optimal fit",
      },
      {
        id: nanoid(),
        point: "PUMA Branding gives great design elevation",
      },
      {
        id: nanoid(),
        point: "Rubber outsole for better traction",
      },
    ],

    manufacturer: [
      {
        id: nanoid(),
        point: "SSIPL RETAIL LIMITED IN",
      },

      {
        id: nanoid(),
        point:
          "SIRMOUR VILL-MEHRUWALA,PO-BHAGANI, TEHSIL-PAONTASAHIB,DISTT-SIRMO HP 173025 PAONTASAHIB",
      },
    ],
    cardImages: [
      {
        id: nanoid(),
        imgCard: shoes3,
      },
      {
        id: nanoid(),
        imgCard: shoes31,
      },
      {
        id: nanoid(),
        imgCard: shoes32,
      },
      {
        id: nanoid(),
        imgCard: shoes33,
      },
    ],
  },
  {
    id: nanoid(),
    image: shoes4,
    title: "Mercedes AMG Petronas Drift Cat Decima Youth Sneakers Unisex",
    price: 3599,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "PUMA White-Spectra Green",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "Don the signa of Mercedes-AMG Petronas in these Drift Cat Decima motorsport shoes, which contain a slick silhouette and",
    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information For any queries, please contact Customer Service at 080-35353535 or via customercareindia@puma.com .",
    productStory:
      "Don the signa of Mercedes-AMG Petronas in these Drift Cat Decima motorsport shoes, which contain a slick silhouette and the marque’s famous branding and colour combinations",

    detail: [
      {
        id: nanoid(),
        point: "Synthetic upper",
      },
      {
        id: nanoid(),
        point: "Perforation details on the upper",
      },
      {
        id: nanoid(),
        point: "Mercedes-AMG PETRONAS branding",
      },
      {
        id: nanoid(),
        point: "Rubber midsole",
      },
      {
        id: nanoid(),
        point: "Rubber outsole",
      },
      {
        id: nanoid(),
        point: "PUMA Youth: Recommended for older kids between 8 and 16 years",
      },
    ],

    manufacturer: [
      {
        id: nanoid(),
        point: "VMC Royal Co., Ltd.VN",
      },

      {
        id: nanoid(),
        point:
          "22B Thanh phuoc Hamlet, Thanh dien ward, Chau Thanh district, 840000 TAY NINH PROVINCE",
      },
    ],
    cardImages: [
      {
        id: nanoid(),
        imgCard: shoes4,
      },
      {
        id: nanoid(),
        imgCard: shoes41,
      },
      {
        id: nanoid(),
        imgCard: shoes42,
      },
      {
        id: nanoid(),
        imgCard: shoes43,
      },
    ],
  },
  {
    id: nanoid(),
    image: shoes5,
    title: "Ferrari Drift Cat Dec. Kids' Sneakers Unisex",
    price: 2749,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "Rosso Corsa-PUMA Black-PUMA White",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "For our next generation of motorsport fans, the Scuderia Ferrari Drift Cat Decima Motorsport Shoes will put you streets ahead in",
    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information For any queries, please contact Customer Service at 080-35353535 or via customercareindia@puma.com .",
    productStory:
      "For our next generation of motorsport fans, the Scuderia Ferrari Drift Cat Decima Motorsport Shoes will put you streets ahead in the style stakes. Packed with design details inspired by racing cars, they're this season's must-have for our little racing drivers.",

    detail: [
      {
        id: nanoid(),
        point: "Textile sockliner",
      },
      {
        id: nanoid(),
        point: "Hook-and-loop closure",
      },
      {
        id: nanoid(),
        point:
          "PUMA Kids' style: Recommended for young kids between 4 and 8 years",
      },
    ],

    manufacturer: [
      {
        id: nanoid(),
        point: "BRIGHT FLUSHING CO., LTD KH",
      },

      {
        id: nanoid(),
        point:
          "Takeo Province Phum Thnung Roleung, Khum Leay Bor, Sruk Tram Kok, 210204 Sruk Tram Kok",
      },
    ],
    cardImages: [
      {
        id: nanoid(),
        imgCard: shoes5,
      },
      {
        id: nanoid(),
        imgCard: shoes51,
      },
      {
        id: nanoid(),
        imgCard: shoes52,
      },
      {
        id: nanoid(),
        imgCard: shoes53,
      },
    ],
  },
  {
    id: nanoid(),
    image: shoes6,
    title: "Future Rider Splash Youth Sneakers Unisex",
    price: 2749,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "PUMA Navy-For All Time Red",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "Born in 1980, the Fast Rider launched just as running started moving from the track to the streets. Designed for more",
    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information For any queries, please contact Customer Service at 080-35353535 or via customercareindia@puma.com .",
    productStory:
      "Born in 1980, the Fast Rider launched just as running started moving from the track to the streets. Designed for more unpredictable terrain, the shoe featured an ultra-light padded nylon upper and our supreme shock-absorbing Federbein outsole. In 2021, the iconic version is back - this time as the Future Rider. With bold branding, cool colour combinations and a retro chic silhouette, this playful pair is perfect for pounding the pavement",

    detail: [
      {
        id: nanoid(),
        point: "Nylon upper with suede and synthetic overlays",
      },
      {
        id: nanoid(),
        point: "EVA midsole",
      },
      {
        id: nanoid(),
        point: "Federbein outsole",
      },
      {
        id: nanoid(),
        point: "PUMA Wordmark at tongue and quarter",
      },
      {
        id: nanoid(),
        point: "PUMA Formstrip at lateral sides",
      },
      {
        id: nanoid(),
        point:
          " PUMA Youth style: Recommended for older kids between 8 and 16 years",
      },
    ],

    manufacturer: [
      {
        id: nanoid(),
        point: "BRIGHT FLUSHING CO., LTD",
      },

      {
        id: nanoid(),
        point:
          "KH Takeo Province Phum Thnung Roleung, Khum Leay Bor, Sruk Tram Kok, 210204 Sruk Tram Kok",
      },
    ],
    cardImages: [
      {
        id: nanoid(),
        imgCard: shoes6,
      },
      {
        id: nanoid(),
        imgCard: shoes61,
      },
      {
        id: nanoid(),
        imgCard: shoes62,
      },
      {
        id: nanoid(),
        imgCard: shoes63,
      },
    ],
  },
  {
    id: nanoid(),
    image: shoes7,
    title: "Future Rider Splash Youth Sneakers Women",
    price: 3499,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "Ash Gray-Strawberry Burst",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "Born in 1980, the Fast Rider launched just as running started moving from the track to the streets. Designed for more",
    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information For any queries, please contact Customer Service at 080-35353535 or via customercareindia@puma.com .",
    productStory:
      "Born in 1980, the Fast Rider launched just as running started moving from the track to the streets. Designed for more unpredictable terrain, the shoe featured an ultra-light padded nylon upper and our supreme shock-absorbing Federbein outsole. In 2021, the iconic version is back - this time as the Future Rider. With bold branding, cool colour combinations and a retro chic silhouette, this playful pair is perfect for pounding the pavement",

    detail: [
      {
        id: nanoid(),
        point: "Nylon upper with suede and synthetic overlays",
      },
      {
        id: nanoid(),
        point: "EVA midsole",
      },
      {
        id: nanoid(),
        point: "Federbein outsole",
      },
      {
        id: nanoid(),
        point: "PUMA Wordmark at tongue and quarter",
      },
      {
        id: nanoid(),
        point: "PUMA Formstrip at lateral sides",
      },
      {
        id: nanoid(),
        point:
          " PUMA Youth style: Recommended for older kids between 8 and 16 years",
      },
    ],

    manufacturer: [
      {
        id: nanoid(),
        point: "BRIGHT FLUSHING CO., LTD",
      },

      {
        id: nanoid(),
        point:
          "KH Takeo Province Phum Thnung Roleung, Khum Leay Bor, Sruk Tram Kok, 210204 Sruk Tram Kok",
      },
    ],
    cardImages: [
      {
        id: nanoid(),
        imgCard: shoes7,
      },
      {
        id: nanoid(),
        imgCard: shoes71,
      },
      {
        id: nanoid(),
        imgCard: shoes72,
      },
      {
        id: nanoid(),
        imgCard: shoes73,
      },
    ],
  },
  {
    id: nanoid(),
    image: shoes8,
    title: "Basket Classic one8 Kid's Sneakers Women",
    price: 2119,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "Dark Denim-Puma Team Gold",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "Energize your athletic spirit with PUMA x one8 Virat Kohli collection. Echoing Virat's favourites, the dynamic sportswear",
    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information For any queries, please contact Customer Service at 080-35353535 or via customercareindia@puma.com .",
    productStory:
      "This versatile pair of sneakers is for all the young Virat and PUMA fans. Inspired by cricket and evolved from the classic PUMA Basket, the Basket Classic one8 sneaker is the perfect interpretation of Virat’s personal style and appeal with a design sense handpicked by him and brought to life for him by PUMA.",

    detail: [
      {
        id: nanoid(),
        point: "Heel type: Flat",
      },
      {
        id: nanoid(),
        point: "Shoe width: Regular fit",
      },
      {
        id: nanoid(),
        point: "Premium synthetic leather upper",
      },
      {
        id: nanoid(),
        point: "Lace closure for snug fit",
      },
      {
        id: nanoid(),
        point:
          "Golden stitch Details at the forefoot inspired from the stitches on the cricket ball",
      },
      {
        id: nanoid(),
        point: "one8 and PUMA Cat logo on the tongue",
      },
      {
        id: nanoid(),
        point: "PUMA logo at lateral side",
      },
      {
        id: nanoid(),
        point: "PUMA Formstrip and perforated detail at lateral sides",
      },
      {
        id: nanoid(),
        point:
          "Unique execution of one8 logo on the heel counter on left and right footwear",
      },
      {
        id: nanoid(),
        point:
          "Translucent iced rubber outsole offers durability and protection for all kinds of versatile movements in the city",
      },
      {
        id: nanoid(),
        point: "one8 logo on the outsole",
      },
    ],

    manufacturer: [
      {
        id: nanoid(),
        point: "MOCHIKO SHOES PRIVATE LIMITED",
      },

      {
        id: nanoid(),
        point:
          "IN UTTRAKHAND KHASRA NO 3914, MOUZA MAZRI GRANT, LAL TAPPER INDUSTRIAL AREA, NH-72, 248140 DEHRADUN",
      },
    ],
    cardImages: [
      {
        id: nanoid(),
        imgCard: shoes8,
      },
      {
        id: nanoid(),
        imgCard: shoes81,
      },
      {
        id: nanoid(),
        imgCard: shoes82,
      },
      {
        id: nanoid(),
        imgCard: shoes83,
      },
    ],
  },
  {
    id: nanoid(),
    image: shoes9,
    title: "X-Ray Speed Lite Youth Sneakers Unisex",
    price: 2119,
    offer: "10% discount on prepaid order",
    button: "Add To Cart",
    color: "Shadow Gray-PUMA Black-PUMA Team Royal",
    size: "Uk 7",
    qty: 1,
    checked: false,
    description:
      "The new season X-Ray Speed Lite comes with a simplified upper without compromising on the DNA of the X-Ray family",
    returns:
      "Free return for all qualifying orders within 14 days of your order delivery date. Visit our Return Policy for more information For any queries, please contact Customer Service at 080-35353535 or via customercareindia@puma.com .",
    productStory:
      "The new season X-Ray Speed Lite comes with a simplified upper without compromising on the DNA of the X-Ray family. The lightweight mesh upper features an intriguing two-piece eyestay and details at the heel, perfect for leaving a stylish impression. And with the X-Ray signature SoftFoam+ sockliner and IMEVA midsole, your feet will not only look good, but feel great, too",

    detail: [
      {
        id: nanoid(),
        point: "Heel type: Flat",
      },
      {
        id: nanoid(),
        point: "Shoe width: Regular fit",
      },
      {
        id: nanoid(),
        point: "Heel-to-toe-drop: 0 mm",
      },
      {
        id: nanoid(),
        point: "Low boot silhouette",
      },
      {
        id: nanoid(),
        point: "Mesh upper with synthetic overlays",
      },
      {
        id: nanoid(),
        point: "SoftFoam+ sockliner",
      },
      {
        id: nanoid(),
        point: "IMEVA midsole",
      },
      {
        id: nanoid(),
        point: "Rubber outsole",
      },
      {
        id: nanoid(),
        point: "Lace closure for a snug fit",
      },
      {
        id: nanoid(),
        point: "Two-piece eyestay and painted midsole as a design feature",
      },
      {
        id: nanoid(),
        point: "PUMA Formstrip at lateral side",
      },
      {
        id: nanoid(),
        point: "PUMA branding at heel, quarter and tongue",
      },
      {
        id: nanoid(),
        point:
          "PUMA Youth style: Recommended for older kids between 8 and 16 years",
      },
    ],

    manufacturer: [
      {
        id: nanoid(),
        point: "Putian Xinlong Footwear Co Ltd.",
      },

      {
        id: nanoid(),
        point: "FCNXF Fujian Shuinan Village Huangshi Town 351144 PUTIAN",
      },
    ],
    cardImages: [
      {
        id: nanoid(),
        imgCard: shoes9,
      },
      {
        id: nanoid(),
        imgCard: shoes91,
      },
      {
        id: nanoid(),
        imgCard: shoes92,
      },
      {
        id: nanoid(),
        imgCard: shoes93,
      },
    ],
  },
];
